import { useInputMode } from "../context/InputModeContext";

const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

const smoothScroll = (ref, target, duration, isMouseFocus) => {
  try {
    // Input mode for scroll behavior
    const start = ref.current.scrollTop;
    const change = target - start;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      try {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // Clamp between 0 and 1
        const easedProgress = easeInOutCubic(progress); // Apply easing

        ref.current.scrollTop = start + change * easedProgress;

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      } catch (err) { }
    };

    if (isMouseFocus) return;

    requestAnimationFrame(animateScroll);
  } catch (error) { }
};

export default smoothScroll;
